"use client";

import { cn } from "@/lib/utils";

interface PillSwitcherProps<T extends string> {
  options: { value: T; label: string }[];
  value: T;
  onChange: (v: T) => void;
}

export default function PillSwitcher<T extends string>({
  options,
  value,
  onChange,
}: PillSwitcherProps<T>) {
  return (
    <div
      role="group"
      className="bg-muted border-border inline-flex items-center gap-0.5 rounded-full border p-0.5"
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={cn(
            "rounded-full px-3 py-1.5 text-xs font-semibold whitespace-nowrap transition-colors duration-200",
            value === opt.value
              ? "bg-primary text-primary-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
          aria-pressed={value === opt.value}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
